// App来源
export enum EAppSource {
  JD = 'jdmall', // 京东
  JDJR = 'jdjr', // 京东金融
}

// 手机操作系统
export enum EPhoneOS {
  Android = 'android',
  IOS = 'iOS',
}
